import { jsx as _jsx } from "react/jsx-runtime";
export const Spacer = () => (_jsx("span", { style: { flex: 1, margin: 0 } }));
export default Spacer;
//# sourceMappingURL=Spacer.js.map